import { API } from '../../shared/constants/constants';
import { normalizeServiceId } from '../../shared/utils/serviceLogNormalization';

export const duplicateServiceLog = async (id) => {
  const normalizedId = normalizeServiceId(id);
  if (!normalizedId) {
    throw new Error('invalid service id');
  }
  const res = await API.post(`/service/${normalizedId}/duplicate`);
  return res.data;
};

export const duplicateMediaInteraction = async (id) => {
  const res = await API.post(`/issue/${id}/duplicate`);
  return res.data;
};

export const duplicateEngagementLog = async (id) => {
  const res = await API.post(`/engagement/${id}/duplicate`);
  return res.data;
};

export const getFlatIssueById = async (id) => {
  return await API.get(`issue/${id}/flat`);
};

export const getFlatServiceById = async (id) => {
  const normalizedId = normalizeServiceId(id);
  if (!normalizedId) {
    throw new Error('invalid service id');
  }
  return await API.get(`service/${normalizedId}/flat`);
};

export const getFlatEngagementById = async (id) => {
  return await API.get(`engagement/${id}/flat`);
};

export const getFlatContentLogById = async (id) => {
  return await API.get(`content-log/${id}/flat`);
};
